import {
  getPendingRefunds,
  PendingRequestTabTypes,
} from '@pharmaplan/common';

const { pendingRefunds } = PendingRequestTabTypes;

const usePendingRefundTabs = (selectedTab: PendingRequestTabTypes) => {
  const config = {
    [pendingRefunds]: {
      api: getPendingRefunds,
    },

  };
  return { config: config[selectedTab] };
};

export default usePendingRefundTabs;
